import AdvertorialAdSpot from './adSpot/AdvertorialAdSpot';
import renderAdGenerator from './generator/renderAd';

var renderAd = function renderAd(adContent, container) {
  var adSpot = new AdvertorialAdSpot({
    config: {},
    container: container
  });
  renderAdGenerator(adSpot)(adContent);
};

export default renderAd;
//# sourceMappingURL=renderAd.js.map